module.exports = __webpack_public_path__ + "img/fav_logo.4dc189db.svg";